import { defineComponent as r, useSlots as o, unref as t, openBlock as l, createBlock as a, normalizeClass as m, withCtx as d, renderSlot as c } from "vue";
import "./ghl-ui.es65.js";
import "./ghl-ui.es334.js";
import n from "./ghl-ui.es335.js";
import u from "./ghl-ui.es118.js";
const f = r({
  name: "UIDivider",
  inheritAttrs: !1
}), h = r({
  ...f,
  props: {
    titlePlacement: {
      type: String,
      default: "center"
    },
    dashed: {
      type: Boolean,
      default: !1
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    legacy: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const s = o();
    return (i, v) => t(s).default ? (l(), a(t(n), {
      key: 0,
      "title-placement": e.titlePlacement,
      dashed: e.dashed,
      vertical: e.vertical,
      class: m([!e.legacy && "hlui-divider"])
    }, {
      default: d(() => [
        e.legacy ? c(i.$slots, "default", { key: 0 }) : (l(), a(t(u), {
          key: 1,
          id: "hlui-divider-text",
          size: "md",
          weight: "medium"
        }, {
          default: d(() => [
            c(i.$slots, "default")
          ]),
          _: 3
        }))
      ]),
      _: 3
    }, 8, ["title-placement", "dashed", "vertical", "class"])) : (l(), a(t(n), {
      key: 1,
      "title-placement": e.titlePlacement,
      dashed: e.dashed,
      vertical: e.vertical
    }, null, 8, ["title-placement", "dashed", "vertical"]));
  }
}), x = h;
export {
  x as default
};
